<template>
  <div class="kws-int-container">
    <introduction
      v-if="step === 0"
      :fsCcAttrs="introduction.fsCcAttrs"
      :headline="introduction.headline"
      :text="introduction.text"
      :img="introduction.img"
      @start="goOn"
    ></introduction>
    <question
      v-if="step > 0 && questions && step <= questions.length"
      :step="step"
      :id="questions[step - 1].id"
      :fsCcAttrs="questions[step - 1].fsCcAttrs"
      :total="result.registration ? questions.length + 1 : questions.length"
      :text="questions[step - 1].text"
      :img="questions[step - 1].img"
      :answers="questions[step - 1].answers"
      :first="!introduction"
      :last="step === questions.length"
      :disable-back-button="true"
      :provide-solution="true"
      @go-on="goOn"
      @evaluate-result="evaluateResult"
    ></question>
    <outro
      v-if="
        (step > questions.length && !result.registration) ||
        (step > questions.length && result.registration && submitted)
      "
      :fsCcAttrs="result.fsCcAttrs"
      :headline="result.headline"
      :text="
        result.registration && submitted
          ? result.registration.registrationSuccessfulText
          : resultText
      "
      :img="result.img"
    ></outro>
    <!-- eslint-disable -->
    <registration
      v-if="step > questions.length && result.registration && !submitted"
      :fsCcAttrs="result.registration.fsCcAttrs"
      :step="step"
      :error="error"
      :errorText="errorText"
      :result="result"
      :resultText="resultText"
      :text="result.registration.text"
      :img="result.registration.img"
      v-model="result.registration.form"
      @go-back="goBack"
      @submit="register"
    ></registration>
    <!-- eslint-enable -->
  </div>
</template>

<script>
import { localizeContent } from '@/shared/Utils';
import Introduction from './introduction.vue';
import Question from './question.vue';
import Outro from './outro.vue';
import Registration from './registration-form.vue';

export default {
  components: {
    Introduction,
    Question,
    Outro,
    Registration,
  },
  props: {
    id: {
      type: String,
      required: true,
    },
    introduction: Object,
    questions: Array,
    result: Object,
  },
  data: () => ({
    step: 0,
    resultText: '',
    error: false,
    errorText: '',
    submitted: false,
  }),
  methods: {
    goBack() {
      this.step -= 1;
    },
    goOn() {
      this.step += 1;
    },
    evaluateResult() {
      this.step += 1;
      const numberOfCorrectlyAnsweredQuestions = this.questions.filter(
        (question) => {
          const selectedAnswerValues = question.answers.options
            .filter((option) => option.selected)
            .map((option) => option.value);
          selectedAnswerValues.sort();
          question.answers.solution.validAnswers.sort();
          return (
            JSON.stringify(selectedAnswerValues)
            === JSON.stringify(question.answers.solution.validAnswers)
          );
        },
      ).length;
      const percentage = Math.round(
        (numberOfCorrectlyAnsweredQuestions / this.questions.length) * 100,
      );
      let i = this.result.grading.length - 1;
      while (i > 0) {
        if (this.result.grading[i].min < percentage) {
          break;
        }
        i -= 1;
      }
      this.resultText = this.result.grading[i].message
        .replace(/{count}/, localizeContent(numberOfCorrectlyAnsweredQuestions))
        .replace(/{total}/, localizeContent(this.questions.length));
      this.handIn();
    },
    async handIn() {
      this.working = true;

      const apiData = {
        formName: `quiz-quiz-${this.id}`,
        data: {},
      };
      this.questions.forEach((q) => {
        apiData.data[q.id] = {
          value: q.answers.options
            .filter((o) => o.selected)
            .reduce(
              (previousAnswer, answer) => `${previousAnswer}${answer.value},`,
              '',
            )
            .replace(/,+$/g, ''),
        };
      });

      try {
        await this.$http.post(
          `${this.result.apiUrl}quiz/quiz-quiz-${this.id}`,
          apiData,
        );
      } catch (error) {
        this.error = true;
      }

      this.working = false;
    },
    register() {
      const data = {};

      data.account = {};
      data.profile = {};
      data.profile.address = {};
      data.profile.features = {};
      data.profile.features.data = {};
      data.profile.features.data.crops = {};
      data.profile.features.legalPermissions = {};

      Object.keys(this.result.registration.form).forEach((key) => {
        const { value } = this.result.registration.form[key];
        data.profile.salutation = this.result.registration.form.salutation.value;
        data.profile.title = this.result.registration.form.title.value;
        data.profile.features.privacyStatementAccepted = this.result.registration.form.acceptTerms.value;
        // eslint-disable-next-line default-case
        switch (key) {
          case 'firstName':
            data.profile.firstname = value;
            break;
          case 'lastName':
            data.profile.lastname = value;
            break;
          case 'email':
            data.account.email = value;
            break;
          case 'postalCode':
            data.profile.address.zip = value.trim();
            break;
          case 'city':
            data.profile.address.city = value;
            break;
          case 'company':
            data.profile.address.company = value;
            break;
          case 'district':
            data.profile.address.district = value;
            break;
          case 'country':
            data.profile.address.country = this.result.registration.form.country.value;
            break;
          case 'street':
            data.profile.address.street = value;
            break;
          case 'password':
            data.account.password = value;
            break;
        }
      });

      fetch(`${this.result.registration.apiUrl}`, {
        method: 'POST',
        body: JSON.stringify(data),
        headers: {
          'Content-Type': 'application/json',
        },
      }).then((response) => {
        if (response.status === 200) {
          response.json().then(() => {
            this.setCookie();
          });
        } else {
          response.json().then((d) => {
            d.errors.forEach((error) => {
              this.error = true;
              this.errorText = error.error;
              const element = document.getElementById(this.id);
              element.scrollIntoView({ behavior: 'smooth' });
            });
          });
        }
      });
    },
    setCookie() {
      const cookieDate = new Date();
      cookieDate.setFullYear(cookieDate.getFullYear() + 10);
      document.cookie = `kws.quiz.${
        this.id
      }.registered=true; expires=${cookieDate.toUTCString()};`;
      this.submitted = true;
    },
  },
  created() {
    if (!this.introduction) {
      this.step = 1;
    }
    this.submitted = !!document.cookie
      .split('; ')
      .find((row) => row.startsWith(`kws.quiz.${this.id}.registered`));
  },
};
</script>
